import { setToken, getToken, removeToken } from '@/utils/auth'
import { getInfo, login, logout } from '@/api/userApi'

let userStore = {
  state: {
    loginFlag:false,
    token: getToken(),
    userName: '',
    userId: '',
    nickName: '',
    avatar: '',
  },
  getters: {
    loginFlag: state => state.loginFlag,
    userName: state => state.userName,
    userId: state => state.userId,
    nickName: state => state.nickName,
    avatar: state => state.avatar,
    token: state => state.token,
  },
  mutations: {
    setLoginFlag(state,loginFlag){
      state.loginFlag = loginFlag;
    },
    setToken(state,token){
      state.token = token;
    },
    setUserName(state,userName){
      state.userName = userName;
    },
    setUserId(state,userId){
      state.userId = userId;
    },
    setNickName(state,nickName){
      state.nickName = nickName;
    },
    setAvatar(state,avatar){
      state.avatar = avatar;
    }
  },
  actions: {
    /**
     * 登录
     * @param commit
     * @param userInfo
     * @returns {Promise<unknown>}
     * @constructor
     */
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if(res && res.code == 200){
            setToken(res.token)
            commit('setToken', res.token)
            commit('setLoginFlag', true)
            resolve()
          }else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 获取用户信息
     * @param commit
     * @param state
     * @returns {Promise<unknown>}
     * @constructor
     */
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          commit('setUserName', user.userName)
          commit('setUserId', user.userId)
          commit('setNickName', user.nickName)
          commit('setAvatar', user.avatar)
          commit('setLoginFlag', true)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 退出系统
     * @param commit
     * @param state
     * @returns {Promise<unknown>}
     * @constructor
     */
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('setUserName', '')
          commit('setNickName', '')
          commit('setAvatar', '')
          commit('setLoginFlag', false)
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}
export default userStore
